import { Type } from '@angular/core';
import { ChartType } from '../models/chart.models';
import {
  ChartGaugeComponent,
  ChartBarComponent,
  ChartLineComponent,
  ChartPieComponent
} from '../components';

export const ChartTypes = {
  Gauge: 'gauge',
  Bar: 'bar',
  Line: 'line',
  Pie: 'pie',
  Doughnut: 'doughnut',
  Scatter: 'scatter',
  Bubble: 'bubble',
  PolarArea: 'polarArea',
  Radar: 'radar',
};

export const CHART_TYPES: Record<ChartType, Type<unknown> | undefined> = {
  gauge: ChartGaugeComponent,
  bar: ChartBarComponent,
  line: ChartLineComponent,
  pie: ChartPieComponent,
  doughnut: undefined,
  scatter: undefined,
  bubble: undefined,
  polarArea: undefined,
  radar: undefined,
};

export const ALLOWED_INPUTS_BY_TYPE: Record<ChartType, string[]> = {
  gauge: [
    'min',
    'max',
    'value',
    'units',
    'progressColor',
    'remainingColor',
    'unitsMax',
    'unitsMin',
    'showBadge',
    'showValue',
    'showPercentage',
    'showMaxMin',
    'showVariations',
    'variations',
  ],
  bar: ['datasets', 'color', 'height', 'annotations', 'options', 'legendLabel', 'units', 'labels', 'showCustomLegend'],
  line: ['datasets', 'labels', 'height', 'options', 'legendLabel', 'units', 'labels'],
  pie: ['datasets', 'labels', 'height', 'options', 'legendLabel', 'units', 'labels'],
};
